<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view/>
    </a-config-provider>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  data() {
    return {
      locale: zhCN,
      _beforeUnload_time: 0,
    }
  },
  mounted(){
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
  },
  methods: {
    beforeunloadHandler(){
      this._beforeUnload_time=new Date().getTime()
    },
    unloadHandler() {
      let gap_time= new Date().getTime() - this._beforeUnload_time;
      if (gap_time <= 5) {
        localStorage.clear();
      }
    }
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.removeEventListener('unload', e => this.unloadHandler(e))
  }
}
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
  background-color: #f4f4f4;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3038;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3038;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
